import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-81a1a178"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "patientInfoPopup",
  class: "popup-vue"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "popup-top" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "body-title" }, [
    /*#__PURE__*/_createElementVNode("h1", null, "환자 정보"),
    /*#__PURE__*/_createElementVNode("p", null, "선택한 환자 정보입니다.")
  ])
], -1))
const _hoisted_3 = {
  id: "patientInfo",
  class: "popup-content"
}
const _hoisted_4 = { action: "" }
const _hoisted_5 = { class: "" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("legend", { class: "hidden" }, "기본 정보", -1))
const _hoisted_7 = { class: "content" }
const _hoisted_8 = { class: "content-left" }
const _hoisted_9 = { class: "input-item" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "patientNameEn" }, "이름", -1))
const _hoisted_11 = { class: "input-item" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "id" }, "아이디(이메일)", -1))
const _hoisted_13 = { class: "input-item" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "nationality" }, "국가", -1))
const _hoisted_15 = { class: "content-right" }
const _hoisted_16 = { class: "input-item medical-disease-kr" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "관심 진료질환", -1))
const _hoisted_18 = { key: 0 }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "option-result-none" }, "없음", -1))
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = {
  key: 1,
  class: "option-results"
}
const _hoisted_22 = { class: "popup-bottom btn-wrap" }

import { onBeforeMount } from 'vue';
import { computed } from '@vue/reactivity';
import { useStore } from 'vuex';

export default /*#__PURE__*/_defineComponent({
  __name: 'PatientInfoPopup',
  props: {
  popupTitle: {
    type: String,
    required: false,
  },
  currentPatient: {
    type: Object,
    required: true,
  },
},
  emits: ['onClick_close'],
  setup(__props, { emit }) {

const props = __props;

const store = useStore();
const Pt = store.state.modulePt;
var patientInfo = computed(() => Pt.patientInfo);


/**** methods ----------------- */
const setPatientInfo = () => {
  store.dispatch('modulePt/getPatientInfo', props.currentPatient.patientSid, { root: true });
};
/**** content -----------------
 *
 * 환자 상세 정보
 * /
 * /
/**** hook -------------------- */
onBeforeMount(() => {
  setPatientInfo();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("form", _hoisted_4, [
        _createElementVNode("fieldset", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _withDirectives(_createElementVNode("input", {
                  class: "input-name",
                  type: "text",
                  name: "patientNameEn",
                  id: "patientNameEn",
                  placeholder: "이름 입력",
                  minlength: "10",
                  maxlength: "100",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(patientInfo).patientName) = $event)),
                  readonly: "true"
                }, null, 512), [
                  [_vModelText, _unref(patientInfo).patientName]
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _withDirectives(_createElementVNode("input", {
                  class: "input-id",
                  type: "text",
                  name: "patientId",
                  id: "patientId",
                  placeholder: "example@email.com",
                  minlength: "10",
                  maxlength: "100",
                  pattern: "",
                  required: "true",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(patientInfo).patientId) = $event)),
                  readonly: "true"
                }, null, 512), [
                  [_vModelText, _unref(patientInfo).patientId]
                ])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                _withDirectives(_createElementVNode("input", {
                  class: "input-search",
                  type: "search",
                  name: "nationality",
                  id: "nationality",
                  placeholder: "국가 검색",
                  minlength: "10",
                  maxlength: "100",
                  pattern: "",
                  required: "true",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(patientInfo).nationality) = $event)),
                  readonly: "true"
                }, null, 512), [
                  [_vModelText, _unref(patientInfo).nationality]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _hoisted_17,
                (_unref(patientInfo).interestingDiseases === null)
                  ? (_openBlock(), _createElementBlock("ul", _hoisted_18, _hoisted_20))
                  : (_openBlock(), _createElementBlock("ul", _hoisted_21, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(patientInfo).interestingDiseases, (item) => {
                        return (_openBlock(), _createElementBlock("li", {
                          class: "option-result-list",
                          key: item
                        }, _toDisplayString(item), 1))
                      }), 128))
                    ]))
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_22, [
      _createElementVNode("button", {
        class: "btn-confirm",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('onClick_close')))
      }, "닫기")
    ])
  ]))
}
}

})